// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"SO-z","categoryName":"TO-z","categoryNameSearchHeader":"UO-z","categoryContent":"VO-z","bottomAligned":"WO-z","image":"XO-z","imageNoBackground":"YO-z"};